// Typelizer digest d0d627ee1ebac3a800d44a9f0976afa2
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /educators/teachers/:teacher_id/teams/:team_id/team_timetable/edit */
  edit: (
    params: { teacherId: string | number; teamId: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/teams/:team_id/team_timetable/edit', params, options),
    method: 'get',
  }),

  /** PATCH /educators/teachers/:teacher_id/teams/:team_id/team_timetable */
  update: (
    params: { teacherId: string | number; teamId: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/teams/:team_id/team_timetable', params, options),
    method: 'patch',
  }),
}
